import { render } from "./header2.vue?vue&type=template&id=33d3cd72&scoped=true"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"

import "./header2.vue?vue&type=style&index=0&id=33d3cd72&scoped=true&lang=less"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d3cd72"]])

export default __exports__